<mat-form-field
	[appearance]="appearance"
	class="filter-dialog__field filter-dialog__field--full filter-dialog__field--mls"
	[hidden]="(hiddenWhileLoading && isLoading) || (hiddenWhenOnlyOneOption && !!options.length && options.length === 1)"
>
	<mat-label>{{ placeholderLabel | translate }}</mat-label>
	<mat-select [value]="value" [disabled]="disabled" (selectionChange)="onSelect($event)" [panelClass]="panelClass">
		<mat-select-trigger>
			<ng-container *ngIf="selectedOption as option; else mlsPlaceholder">
				<div class="selected-option-container">
					<ng-container *ngTemplateOutlet="mlsItem; context: { $implicit: option }"></ng-container>
				</div>
			</ng-container>
			<ng-template #mlsPlaceholder>{{ placeholderFallback | translate }}</ng-template>
		</mat-select-trigger>

		<mat-option *ngIf="!options?.length" [disabled]="true">
			{{ emptyLabel | translate }}
		</mat-option>

		<mat-option *ngFor="let option of options" [value]="option.integrationConfigId" class="mls-select-item">
			<ng-container *ngTemplateOutlet="mlsItem; context: { $implicit: option }"></ng-container>
		</mat-option>
	</mat-select>

	<ng-template #mlsItem let-option>
		<div class="filter-dialog__mls-option">
			<span class="filter-dialog__mls-provider">{{
				'personalization.integration.providers.' + option.provider | translate
			}}</span>
			<span class="filter-dialog__mls-code">MLS ID: {{ option.token }}</span>
		</div>
	</ng-template>
</mat-form-field>
